module.exports = __webpack_public_path__ + "img/funnel_type_radio_logo_2.4c66c279.svg";